import axios from "axios";
import { compress } from "../helpers/common.helper";

const apiUri = import.meta.env.GATEWAY_URI;

export default function useCommission() {
  const createCommission = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/commissions`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data?.data;
  };

  const patchCommission = async (id, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/commissions/${id}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return result.data;
  };

  const queryCommissions = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (sort) reqBody.sort = sort;
    if (project) reqBody.project = project;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/commissions/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getCommission = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/commissions/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  const createSubmission = async (commissionId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/commissions/${commissionId}/submissions`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data?.data;
  };

  const querySubmissions = async (
    commissionId,
    filter,
    page,
    limit,
    project,
    sort
  ) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (sort) reqBody.sort = sort;
    if (project) reqBody.project = project;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(
      `${apiUri}/api/v1/commissions/${commissionId}/submissions/query`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const uploadSubmissionFiles = async (commissionId, submissionId, files) => {
    let data = new FormData();

    for (const image of files) {
      data.append("files", image, image.name);
    }

    const result = await axios.post(
      `${apiUri}/api/v1/commissions/${commissionId}/submissions/${submissionId}/files/upload`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          maxBodyLength: Infinity,
        },
      }
    );

    return result.data.data?.attachments;
  };

  const getSubmissionFiles = async (commissionId, submissionId) => {
    const result = await axios.get(
      `${apiUri}/api/v1/commissions/${commissionId}/submissions/${submissionId}/files`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data?.data;
  };

  const downloadSubmissionFiles = async (
    commissionId,
    submissionId,
    fileIds
  ) => {
    const _body = compress(JSON.stringify({ files: fileIds }));

    const result = await axios.post(
      `${apiUri}/api/v1/commissions/${commissionId}/submissions/${submissionId}/files/download`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result?.data?.data;
  };

  const patchSubmission = async (commissionId, submissionId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/commissions/${commissionId}/submissions/${submissionId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  return {
    createCommission,
    queryCommissions,
    patchCommission,
    getCommission,
    createSubmission,
    querySubmissions,
    uploadSubmissionFiles,
    getSubmissionFiles,
    downloadSubmissionFiles,
    patchSubmission,
  };
}
